import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoginForm from './components/LoginForm';

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/vacancy', { replace: true });
  }, [user, navigate]);

  const handleLogin = async (loginVal: string, password: string) => {
    const ok = await login(loginVal, password);
    if (ok) navigate('/vacancy', { replace: true });
    return ok;
  };

  return (
    <div className="min-h-screen flex bg-[#0d0f18]">
      {/* Left branding panel */}
      <div className="hidden lg:flex lg:w-[45%] relative flex-col items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0a1628 0%, #0d2318 50%, #0a1628 100%)',
          }}
        />
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20geometric%20corporate%20network%20pattern%2C%20hexagonal%20mesh%2C%20dark%20teal%20emerald%20tones%2C%20futuristic%20technology%20background%2C%20subtle%20glow%20lines%2C%20deep%20dark%20background%2C%20minimal%20high-tech%20design%2C%20interconnected%20nodes%20pattern&width=700&height=900&seq=login_bg_001&orientation=portrait"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0f18]/60 via-transparent to-[#0d0f18]/80" />

        <div className="relative z-10 flex flex-col items-center text-center px-12">
          <div className="mb-10">
            <div
              className="w-24 h-24 rounded-3xl flex items-center justify-center border border-emerald-500/30"
              style={{
                background: 'linear-gradient(135deg, rgba(16,185,129,0.15), rgba(16,185,129,0.05))',
                boxShadow: '0 0 40px rgba(74,222,128,0.15)',
              }}
            >
              <i className="ri-shield-user-line text-5xl text-emerald-400" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-white mb-3 leading-tight">
            Корпоративный портал
          </h2>
          <p className="text-slate-500 text-sm tracking-wide mb-6">для сотрудников</p>
          <p className="text-slate-400 text-base leading-relaxed max-w-xs">
            Единое пространство для управления вашим рабочим процессом,
            расписанием и выплатами
          </p>

          <div className="mt-14 grid grid-cols-3 gap-6 w-full">
            {[
              { icon: 'ri-calendar-check-line', label: 'Расписание' },
              { icon: 'ri-wallet-3-line', label: 'Выплаты' },
              { icon: 'ri-folder-line', label: 'Проекты' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-500/10 border border-emerald-500/20">
                  <i className={`${item.icon} text-emerald-400 text-xl`} />
                </div>
                <span className="text-xs text-slate-400">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-6 text-xs text-slate-600 z-10">
          v1.0.0 &nbsp;·&nbsp; 2026
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 lg:px-16">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-emerald-500/10 border border-emerald-500/20">
            <i className="ri-shield-user-line text-2xl text-emerald-400" />
          </div>
        </div>

        <div className="w-full max-w-sm">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-white mb-2">Добро пожаловать</h1>
            <p className="text-slate-500 text-sm">Введите данные для входа в систему</p>
          </div>

          <LoginForm onLogin={handleLogin} />
        </div>

        <p className="mt-12 text-xs text-slate-700 text-center">
          Нет аккаунта? Обратитесь к вашему HR-менеджеру.
        </p>
      </div>
    </div>
  );
}
